export const LOAI_THU_VIEN = {
  THU_VIEN_CHUNG: 'thu-vien-chung',
  THU_VIEN_DON_VI: 'thu-vien-don-vi'
};
